import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Globals } from 'src/app/common/globals';
import { CommonService } from 'src/app/common/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private globals: Globals,
    private commonService: CommonService,
  ) { }

  afterLoginRoutes = [
    'profile',
    'settings',
    'professional',
    'payment-history',
    'my-activities',
    'my-admin',
    'manage',
    'tickets',
    'store',
    'facility',
    'facility-store',
    'application-terms-conditions'
  ];

  afterBeforeLoginRoutes = ['credential-registry', 'store'];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const queryParams = route.queryParams;
    if (
      this.globals.authData &&
      this.commonService.getCookie('access_token') !== null &&
      this.commonService.getCookie('logged_in_user_info') !== null
    ) {
      const currentRoute = this.globals.currentLink.split('/')[1];
      if (
        this.afterLoginRoutes.includes(currentRoute)
      ) {
        return true;
      } else if (
        this.afterBeforeLoginRoutes.includes(currentRoute)
      ) {
        return true;
      } else {

        const hasRedirectTo = queryParams.hasOwnProperty('redirect_to');
        const hasInResponseToId = queryParams.hasOwnProperty('InResponseToId');
        const hasRelayState = queryParams.hasOwnProperty('RelayState');
        const hasLearnUponSSO = queryParams.hasOwnProperty('sso') && queryParams['sso'].toLowerCase() === 'learnupon';

        if (hasRedirectTo && hasInResponseToId && hasRelayState) {
          const redirectTo = queryParams['redirect_to'];
          const inResponseToId = queryParams['InResponseToId'];
          const RelayState = queryParams['RelayState'];

          const redirectToUrl =
            this.globals.baseAPIFolderUrl + '/saml-login/' +
            this.globals.authData.id +
            '?redirect_to=' +
            redirectTo +
            (inResponseToId ? '&InResponseToId=' + inResponseToId : '') +
            (RelayState ? '&RelayState=' + RelayState : '');
          window.location.href = redirectToUrl;
          return false;
        } else if (hasLearnUponSSO) {
          this.commonService.redirectToLearnUponSSO();
          return false;
        } else {
          this.router.navigate(['/professional']);
          return false;
        }
      }
    } else {
      this.commonService.hideLoader();
      if (
        this.globals.currentLink.split('/')[1] == 'store' &&
        !this.globals.currentLink.split('/')[2]
      ) {
        return true;
      } else if (
        this.afterLoginRoutes.includes(this.globals.currentLink.split('/')[1])
      ) {
        this.globals.authData = null;
        this.globals.isLoggedIn = false;
        this.router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    }
  }
}
